import React from 'react';

import { SideNavigationItem, type SideNavigationItemProps } from '@lumapps/lumx-back-office/components/SideNavigation';
import { mdiSpeedometer } from '@lumapps/lumx/icons';
import { useTranslate } from '@lumapps/translations';

import { PLAY_VIDEO_USAGE } from '../../keys';
import { admin } from '../../routes';

export interface VideoUsageSideNavigationProps extends Partial<SideNavigationItemProps> {
    isAllowed: boolean;
}

const VideoUsageSideNavigation: React.FC<VideoUsageSideNavigationProps> = ({ isAllowed, ...restOfProps }) => {
    const { translateKey } = useTranslate();

    if (!isAllowed) {
        return null;
    }

    return (
        <SideNavigationItem
            {...restOfProps}
            label={translateKey(PLAY_VIDEO_USAGE.VIDEO_USAGE)}
            icon={mdiSpeedometer}
            route={admin()}
        />
    );
};

VideoUsageSideNavigation.displayName = 'SideNavigationItem';

export { VideoUsageSideNavigation };
